import Image1 from "../../assets/Icon.png"
import Image2 from "../../assets/iconP.png"
import Image3 from "../../assets/Iconpro.png"
 
export const Data = [
    {
        id: 1,
        image: Image2,
        title: "Uthman Oluwaseun",
        description: "Mustopha delivered exceptional results! His expertise as a full-stack developer transformed our project beyond expectations. Highly recommend!"
    },
    {
        id: 2,
        image: Image1,
        title: "Abdulroheem Ismail",
        description: "Working with Mustopha was seamless. His technical skills and attention to detail made our app a success. Great communication throughout!"
    },
    {
        id: 3,
        image: Image3,
        title: "Ibrahim Adeleye",
        description: "Innovative, efficient, and reliable – Mustopha exceeded our goals with his professional approach. Truly a talented developer!"
    },

    
];

